var _g, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 247,
  height: 139,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#reset_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m239.5 35.5-76 96-37-22L7 93.5l232.5-58Z",
  fill: "url(#reset_svg__b)",
  fillOpacity: 0.6
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#reset_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.5 40.832 245.5 0 132.99 77.54 119.237 116 105.69 63.62 60.5 40.832Z",
  fill: "url(#reset_svg__d)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#reset_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.5 89.41 133.211 78 119.5 116l30-26.59Z",
  fill: "url(#reset_svg__f)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M179.86 110 133 78 245.5 0l-65.64 110Z",
  fill: "url(#reset_svg__g)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "reset_svg__d",
  x1: 121.925,
  y1: 115.897,
  x2: 57.292,
  y2: -27.632,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.078,
  stopColor: "#C0C3DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.333,
  stopColor: "#E0E2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.354,
  stopColor: "#F3F4FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "reset_svg__f",
  x1: 138.263,
  y1: 82.483,
  x2: 119.838,
  y2: 116.084,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FA9D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDC1EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "reset_svg__g",
  x1: 138.108,
  y1: 78.542,
  x2: 188.896,
  y2: 110.167,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E7FB"
})), /*#__PURE__*/React.createElement("filter", {
  id: "reset_svg__a",
  x: 0,
  y: 28.5,
  width: 246.5,
  height: 110,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5,
  result: "effect1_foregroundBlur_3850_19069"
})), /*#__PURE__*/React.createElement("filter", {
  id: "reset_svg__c",
  x: 60.5,
  y: 0,
  width: 185,
  height: 116,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_3850_19069"
})), /*#__PURE__*/React.createElement("filter", {
  id: "reset_svg__e",
  x: 119.5,
  y: 78,
  width: 30,
  height: 38,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_3850_19069"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reset_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(9.99998 59.00005 -102.02099 17.29164 156.5 78.5)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#727DB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#727DB5",
  stopOpacity: 0
})))));
export { SvgReset as ReactComponent };
export default "data:image/svg+xml;base64,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";